import './videoPlayer.css';
import Video from "../video/video";
import UtilityService from "../../services/utility.service";
import {format} from "date-fns";
import PopupModel from "../popupModel/popupModel";
const VideoPlayer = ({videoData, handleShowVideoPlayer, classes=''}) => {
    return(
        <PopupModel classes={`width-900 ${classes}`} showPopupModel={handleShowVideoPlayer}>
            <div className="video-player-box black-back margin-b-20">
                <Video videoLink={videoData?.player?.videoLink} autoPlay={true} controls={true} />
            </div>

            <div className="font-14 flex">
                <div className="flex gap-15 sf-medium">
                    <div className={`rating-box ${videoData?.other?.alertType}`}>{UtilityService.getAlertName(videoData?.other?.alertType)}</div>
                    <div className="font-15">
                        <span className={'margin-r-15'}>{format(new Date(videoData?.other?.timestampInISO), 'HH:mm')}</span>
                        {format(new Date(videoData?.other?.timestampInISO), 'dd LLL yyyy')}
                    </div>
                </div>
                <ul className="separator gap-30 sf-bold">
                    <li>{videoData?.other?.plateNo}</li>
                    {/*<li>Driver: <span className={'blue-color'}>Babu K</span></li>*/}
                </ul>
                {/*<div className="grey-color sf-medium">Eicher/HMV Chennai - Ahmedabad</div>*/}
            </div>
        </PopupModel>
    )
}

export default VideoPlayer;
